interface AppEnvironment {
  apiBaseUrl: string
  wsUrl: string
  debugMode: boolean
  appName: string
}

class AppConfig {
  private static instance: AppConfig
  private environment: AppEnvironment

  private constructor() {
    this.environment = {
      apiBaseUrl: this.getEnvVar('VITE_API_BASE_URL', 'http://localhost:3000'),
      wsUrl: this.getEnvVar('VITE_WS_URL', 'ws://localhost:3000'),
      debugMode: this.getEnvVar('VITE_DEBUG_MODE', 'false') === 'true',
      appName: this.getEnvVar('VITE_APP_NAME', 'WhatsApp Travel Bot')
    }

    if (this.environment.debugMode) {
      console.log('🔧 Environment Configuration:', {
        source: 'Environment Variables',
        config: this.environment,
        rawEnv: {
          VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
          VITE_WS_URL: import.meta.env.VITE_WS_URL,
          VITE_DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE,
          VITE_APP_NAME: import.meta.env.VITE_APP_NAME
        }
      })
    }
  }

  static getInstance(): AppConfig {
    if (!AppConfig.instance) {
      AppConfig.instance = new AppConfig()
    }
    return AppConfig.instance
  }

  private getEnvVar(key: string, defaultValue: string): string {
    const value = import.meta.env[key]
    return value !== undefined ? value : defaultValue
  }

  get apiBaseUrl(): string {
    return this.environment.apiBaseUrl
  }

  get apiLocalUrl(): string {
    return `${this.environment.apiBaseUrl}/api/local`
  }

  get apiAdminUrl(): string {
    return `${this.environment.apiBaseUrl}/api/admin`
  }

  get wsUrl(): string {
    return this.environment.wsUrl
  }

  get debugMode(): boolean {
    return this.environment.debugMode
  }

  get appName(): string {
    return this.environment.appName
  }

  getApiEndpoint(path: string): string {
    return `${this.apiLocalUrl}${path.startsWith('/') ? path : `/${path}`}`
  }

  getAdminEndpoint(path: string): string {
    return `${this.apiAdminUrl}${path.startsWith('/') ? path : `/${path}`}`
  }
}

export const appConfig = AppConfig.getInstance()
export default appConfig
